
export const FETCH_UPLOAD_DATA = 'FETCH_UPLOAD_DATA'
export const FETCHED_UPLOAD_DATA = 'FETCHED_UPLOAD_DATA'